import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface SchoolSpotlightProps {
  schoolName: string;
  location: string;
  image: string;
  alt: string;
  studentsReached: number;
  poundsGrown: number;
  programYear: string;
  testimonial: string;
  teacherName: string;
}

export default function SchoolSpotlight({
  schoolName,
  location,
  image,
  alt,
  studentsReached,
  poundsGrown,
  programYear,
  testimonial,
  teacherName
}: SchoolSpotlightProps) {
  return (
    <div className="bg-card rounded-xl overflow-hidden shadow-brand-md">
      <div className="relative h-64 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="text-xl font-semibold text-text-primary mb-1">{schoolName}</h3>
            <p className="text-sm text-text-secondary flex items-center">
              <Icon name="MapPinIcon" size={16} className="mr-1" />
              {location}
            </p>
          </div>
          <span className="px-3 py-1 bg-accent/10 text-accent text-xs font-semibold rounded-full">
            {programYear}
          </span>
        </div>
        
        <blockquote className="relative pl-4 border-l-4 border-brand-primary">
          <p className="text-sm text-text-secondary italic mb-2">&quot;{testimonial}&quot;</p>
          <cite className="text-xs font-semibold text-text-primary not-italic">- {teacherName}</cite>
        </blockquote>
      </div>
    </div>
  );
}